module.exports = __webpack_public_path__ + "static/media/Developmenticon06.b73d5bf2.png";